export default __webpack_public_path__ + "static/media/aws_logo.e6809d81.png";